<section class="cm-table__container"
	[ngClass]="{'cm-table__container--fullscreen': fullscreen, 'cm-table--loading': (isLoading$ | async)}"
	*ngIf="(rows$ | async) as rows"
	[ngStyle]="{'min-width': minWidth + minWidthUnit, 'max-width': maxWidth ? maxWidth + maxWidthUnit : null}">

	<ng-container *ngIf='isLoading$ | async'>
		<cm-loading-icon class='loading-icon'></cm-loading-icon>
	</ng-container>

	<header class="cm-table__main-title" *ngIf="headerTemplate">
		<ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
	</header>

	<ng-container *ngIf="(groups$ | async) as groups">
		<ng-container *ngIf="(columns$ | async) as columns">
			<section class="cm-table-meta" *ngIf="!tools.includes(toolsEnum.NONE)">
				<div class="cm-table-meta__filter"
					*ngIf="tools.includes(toolsEnum.FILTER) || tools.includes(toolsEnum.FILTER_ONLY)">
					<mat-form-field>
						<mat-label>
							<span cmLocalize="Core/_Shared.Table.FilterLabel.Filter">
								Filter
							</span>
						</mat-label>
						<input #filterInp matInput (keyup)="filter(filterInp.value)" placeholder="Search" type="search">
						<button cm-mini-button *ngIf="filterInp.value" matSuffix mat-button (click)="clearFilter()"
							[attr.aria-label]="'Clear' | cmLocalize:'Core/_Shared.Table.Button.Clear'">
							<ats-icon name="close" [size]="12"></ats-icon>
						</button>
					</mat-form-field>
				</div>
				<ng-container *ngIf="!tools.includes(toolsEnum.FILTER_ONLY)">
					<div class="cm-table-meta__actions">
						<span *ngIf="anyEmptyGroups && tools.includes(toolsEnum.EMPTY_GROUPS)"
							class="cm-table-meta__empty-groups mr-24">
							<button mat-button cm-mini-button (click)="toggleEmptyGroups()">
								<span *ngIf="showEmptyGroups">
									<span cmLocalize="Core/_Shared.Table.Button.HideEmptyGroups">
										Hide Empty Groups
									</span>
								</span>
								<span *ngIf="!showEmptyGroups">
									<span cmLocalize="Core/_Shared.Table.Button.ShowEmptyGroups">
										Show Empty Groups
									</span>
								</span>
							</button>
						</span>
						<span class="cm-table-meta__filter-toggle mr-24"
							*ngIf="tools.includes(toolsEnum.FILTER) && tools.includes(toolsEnum.TOGGLE_FILTER)">
							<button mat-button cm-mini-button (click)="toggleAllFilters()">
								<ats-icon *ngIf="!anyNotFiltered" name="filter-closed" [size]="14"></ats-icon>
								<ats-icon *ngIf="anyNotFiltered" name="filter" [size]="14"></ats-icon>
								<span cmLocalize="Core/_Shared.Table.Button.FilterAllColumns">
									All Columns
								</span>
							</button>
						</span>
						<ng-container *ngIf="tools.includes(toolsEnum.ZOOM)">
							<span class="cm-table-meta__zoom-out">
								<button mat-button cm-mini-button [disabled]="size <= .25" (click)="zoom('out')"
									[attr.aria-label]="'Zoom Out' | cmLocalize:'Core/_Shared.Table.Button.ZoomOut'">
									<ats-icon name="zoom-out" [size]="14"></ats-icon>
								</button>
							</span>
							<span class="cm-table-meta__zoom-reset">
								<button mat-button cm-mini-button [disabled]="size === .75" (click)="zoom('reset')">
									<span cmLocalize="Core/_Shared.Table.Button.Reset">
										Reset
									</span>
								</button>
							</span>
							<span class="cm-table-meta__zoom-in mr-24">
								<button mat-button cm-mini-button [disabled]="size >= 1.5" (click)="zoom('in')"
									[attr.aria-label]="'Zoom In' | cmLocalize:'Core/_Shared.Table.Button.ZoomIn'">
									<ats-icon name="zoom-in" [size]="14"></ats-icon>
								</button>
							</span>
						</ng-container>
						<span class="cm-table-meta__expand-collapse mr-24"
							*ngIf="groups && !!groups.length && tools.includes(toolsEnum.TOGGLE_GROUPS)">
							<button mat-button cm-mini-button (click)="toggleAllGroups()"
								[attr.aria-label]="allOpen ? ('Collapse Groups' | cmLocalize:'Core/_Shared.Table.Button.CollapseGroups') : ('Expand Groups' | cmLocalize:'Core/_Shared.Table.Button.ExpandGroups')">
								<ats-icon *ngIf="!allOpen" name="expand" [size]="14"></ats-icon>
								<ats-icon *ngIf="allOpen" name="collapse" [size]="14"></ats-icon>
							</button>
						</span>
						<!-- <span class="cm-table-meta__export mr-24" *ngIf="tools.includes(toolsEnum.DOWNLOAD)">
							<button mat-button cm-mini-button
								[attr.aria-label]="'Download' | cmLocalize:'Core/_Shared.Table.Button.Download'">
								<ats-icon name="download" [size]="14"></ats-icon>
							</button>
						</span> -->
						<span class="cm-table-meta__fullscreen" *ngIf="tools.includes(toolsEnum.FULLSCREEN)">
							<button mat-button cm-mini-button (click)="toggleFullscreen()"
								[attr.aria-label]="fullscreen ? ('Exit Fullscreen' | cmLocalize:'Core/_Shared.Table.Button.ExitFullscreen') : ('Enter Fullscreen' | cmLocalize:'Core/_Shared.Table.Button.EnterFullscreen')">
								<ats-icon *ngIf="!fullscreen" name="fullscreen-expand" [size]="14"></ats-icon>
								<ats-icon *ngIf="fullscreen" name="fullscreen-collapse" [size]="14"></ats-icon>
							</button>
						</span>
					</div>
				</ng-container>
			</section>

			<ng-container *ngIf="(gridStyles$ | async) as gridStyles">
				<ng-container *ngIf="(sort$ | async) as sort">

					<section *ngIf="(selectable$ | async) && (isSelecting$ | async)" class="cm-table__instructions">
						<span>To toggle a range, select a row then hold the <em>shift</em> key while selecting the row
							at the end of the range within the same group.</span>
					</section>

					<section class="cm-table" [style.font-size.rem]="size">
						<header class="cm-table__header"
							[style.grid-template-columns]="(selectable$ | async) ? '36px ' + gridStyles : gridStyles">
							<span class="cm-table__header-cell" *ngIf="(selectable$ | async)"></span>
							<ng-container *ngFor="let column of columns; trackBy: trackByFn">
								<span class="cm-table__header-cell" *ngIf="!column.hidden">
									<span class="cm-table__title"
										(click)="toggleSort(column.sortKey ? column.sortKey : column.id, column.sortable)"
										[ngClass]="{'cm-table--clickable': column.sortable !== false || column.filterable !== false}">
										<h3 [cmLocalize]="column.localization" [default]="column.name"></h3>
									</span>
									<div class="cm-table__header-icons">
										<span class="cm-table__icon cm-table__icon--filter"
											(click)="toggleFilter(column.id)" *ngIf="column.filterable !== false">
											<ats-icon *ngIf="column.filtered" [size]="10" name="filter"></ats-icon>
											<ats-icon *ngIf="!column.filtered" [size]="10" name="filter-closed">
											</ats-icon>
										</span>
										<span class="cm-table__icon cm-table__icon--sort"
											*ngIf="column.sortable !== false">
											<ats-icon *ngIf="sort.includes(column.sortKey ? column.sortKey : column.id)"
												[size]="10" name="sort_asc">
											</ats-icon>
											<ats-icon
												*ngIf="sort.includes(column.sortKey ? '-' + column.sortKey : '-' + column.id)"
												[size]="10" name="sort_desc">
											</ats-icon>
										</span>
									</div>
								</span>
							</ng-container>
						</header>

						<div class="cm-table__body">
							<ng-container *ngIf="!!(rowCount$ | async) || showEmptyGroups; else noRows">
								<ng-container *ngFor="let row of rows; index as idx; trackBy: trackByFn">
									<ng-container *ngIf="!row.filtered">
										<ng-container *ngIf="!row.data && (showEmptyGroups || row.childCount > 0)">
											<div class="cm-table__group">
												<button *ngIf="(selectable$ | async)"
													[disabled]="row.disabled || !(isSelecting$ | async)" selector
													(click)="toggleSelection(row, idx, $event)"
													class="cm-table__selector-container"
													[ngClass]="{'cm-table__selector-container--selected': row.selected}">
													<ats-icon *ngIf="row.selected" name="circle-check" [size]="14">
													</ats-icon>
													<ats-icon *ngIf="!row.selected" name="not-available" [size]="14">
													</ats-icon>
												</button>
												<ng-container *ngTemplateOutlet="groupTpl; context: { row: row }">
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="row.data">
											<cm-table-row [gridColumns]="gridStyles"
												[ngClass]="{'cm-table__summary': row.id === 'summary', 'cm-table--disabled': row.disabled || row?.data?.disabledStyleAddedToRow}">
												<button *ngIf="(selectable$ | async)"
													[disabled]="row.disabled || !(isSelecting$ | async)"
													(click)="toggleSelection(row, idx, $event)" selector
													class="cm-table__selector-container"
													[ngClass]="{'cm-table__selector-container--selected': row.selected}">
													<ats-icon *ngIf="row.selected" name="circle-check" [size]="14">
													</ats-icon>
													<ats-icon *ngIf="!row.selected" name="not-available" [size]="14">
													</ats-icon>
												</button>
												<ng-container
													*ngTemplateOutlet="rowTpl; context: { row: row, columns: columns }">
												</ng-container>
											</cm-table-row>
										</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
					</section>
				</ng-container>
			</ng-container>

		</ng-container>
	</ng-container>
</section>

<ng-template #groupTpl let-row="row">
	<button class="cm-table__group-content" [ngClass]="row.classes" (click)="toggleGroup(row.id)"
		[disabled]="row.childCount === 0">
		<span class="cm-table__icon cm-table__icon--expansion">
			<ats-icon *ngIf="row.childCount && row.open" [size]="10" name="arrow_down"></ats-icon>
			<ats-icon *ngIf="row.childCount && !row.open" [size]="10" name="arrow_right">
			</ats-icon>
		</span>
		<h2 class="cm-table__group-title">{{ row.name }}</h2>
		<span class="cm-table__group-count">({{ row.childCount || '0' }})</span>
	</button>
</ng-template>

<ng-template #summaryTpl let-columns="columns">
	<ng-container *ngTemplateOutlet="summaryTemplate; context: {columns: columns}"></ng-container>
</ng-template>

<ng-template #rowTpl let-row="row" let-columns="columns">
	<ng-container *ngTemplateOutlet="rowTemplate; context: {row: row.data, columns: columns, meta: row}"></ng-container>
</ng-template>

<ng-template #noRows>
	<section class="cm-table__empty-data">
		<span cmLocalize="Core/_Shared.Table.Content.NoData">
			No data to show
		</span>
	</section>
</ng-template>
